import { GetCountriesAndCitiesState } from './getCountriesAndCities.types'

const initialState: GetCountriesAndCitiesState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
